module.exports = __webpack_public_path__ + "static/media/bg-1.7335cf3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg-1.jpg
// module id = 581
// module chunks = 0